/* Bundle add-to-cart: "Buy X Get Y Free" adds a paid line + a free line of the single jar; Shopify automatic discounts make the free line $0. */
(function () {

  /* Keep the struck-through "before" price identical whether or not Subscribe & Save is ticked. */
  function keepBefore(root) {
    (root || document).querySelectorAll('[data-bundle]').forEach(function (b) {
      var ot = b.querySelector('.bp--ot .kaching-bundles__bar-full-price');
      var sub = b.querySelector('.bp--sub .kaching-bundles__bar-full-price');
      if (ot && sub) sub.textContent = ot.textContent;
    });
  }
  keepBefore(document);
  document.addEventListener('DOMContentLoaded', function () { keepBefore(document); });
  document.addEventListener('shopify:section:load', function (e) { keepBefore(e.target); });
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('form[action*="/cart/add"]')) return;
    var bar = f.querySelector('[data-bundle].kaching-bundles__bar--selected');
    var fr = bar ? (parseInt(bar.dataset.free, 10) || 0) : 0;
    var ad = f.querySelector('[data-addon-card][data-variant]');
    var addOn = ad && ad.querySelector('[data-check].is-checked');
    if (!(bar && fr > 0) && !addOn) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var btn = f.querySelector('[type=submit]'); if (btn) btn.disabled = true;
    var fd = new FormData(f), sp = fd.get('selling_plan'), items;
    if (bar && fr > 0) {
      var base = parseInt(bar.dataset.base, 10);
      var a = { id: base, quantity: parseInt(bar.dataset.paid, 10) || 1 };
      var b = { id: base, quantity: fr, properties: { _free_gift: 'Free' } };
      if (sp) { a.selling_plan = parseInt(sp, 10); b.selling_plan = parseInt(sp, 10); }
      items = [b, a];
    } else {
      var m = { id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity'), 10) || 1 };
      if (sp) m.selling_plan = parseInt(sp, 10);
      items = [m];
    }
    if (addOn) items.push({ id: parseInt(ad.dataset.variant, 10), quantity: 1 });
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function () { var c = document.querySelector('.header__icon--cart'); if (c) c.click(); else window.location.href = '/cart'; })
      .catch(function () { window.location.href = '/cart'; })
      .then(function () { if (btn) btn.disabled = false; });
  }, true);
})();
